import {useQuery, useMutation, useQueryClient} from "@tanstack/react-query";
import {useAxiosPrivate} from "../useAxiosPrivate";

export default function useCardInfoQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const cardInfoGetForBusinessQuery = useQuery({
        queryKey: ["card-info", "get_for_business"],
        queryFn: () =>
            axiosPrivate
                .get("card-info/get_for_business/")
                .then(r => r.data)
    });
    // MUTATIONS ------------------------------------------------------

    const cardInfoChangeActiveCardMutation = useMutation({
            mutationFn: (data) =>
                axiosPrivate
                    .post("card-info/change_active_card/", data)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["card-info"]);
            }
        });

    const cardInfoDeleteCardMutation = useMutation({
            mutationFn: (data) =>
                axiosPrivate
                    .post("card-info/delete_card/", data)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["card-info"]);
            }
        });


    const payForSubscriptionMutation = useMutation({
            mutationFn: (data) =>
                axiosPrivate
                    .post("card-info/pay-for-subscription/", data)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["card-info"]);
            }
        });

    return {
        // Queries
        cardInfoGetForBusinessQuery,
        payForSubscriptionMutation,

        // Mutations
        cardInfoChangeActiveCardMutation,
        cardInfoDeleteCardMutation
    };
}
